import { LogoutRounded } from '@mui/icons-material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { Button, Stack } from '@mui/material';
import { MenuItem, MenuItemStateProps, Modal, Text } from '@src/components';
import { ConfirmModalThemeSnippet, useTheme } from '@src/themes';
import { FC, Fragment, useState } from 'react';
import { useSessionContext } from './session.context';

const LogoutMenu: FC<MenuItemStateProps> = ({ isMini }) => {
  const { doSignOut } = useSessionContext();
  const { COLORS } = useTheme();

  const [displaySignOutDialog, setDisplaySignOutDialog] = useState(false);

  const handleLogout = () => {
    setDisplaySignOutDialog(false);
    doSignOut();
  };

  return (
    <Fragment>
      <ConfirmModalThemeSnippet>
        <Modal
          opened={displaySignOutDialog}
          actions={
            <Stack direction={'row'} justifyContent={'center'} width={'100%'}>
              <Button
                variant='outlined'
                startIcon={<CloseIcon />}
                sx={{ marginLeft: 2 }}
                onClick={() => setDisplaySignOutDialog(false)}
                color={'primary'}
              >
                Não
              </Button>
              <Button
                variant='contained'
                startIcon={<CheckIcon />}
                sx={{ marginLeft: 2 }}
                onClick={() => handleLogout()}
                color={'primary'}
              >
                Sim!
              </Button>
            </Stack>
          }
        >
          <Stack direction={'row'} justifyContent={'center'} width={'100%'} sx={{ paddingBottom: 2 }}>
            <Text>Tem certeza que deseja se desconectar?</Text>
          </Stack>
        </Modal>
      </ConfirmModalThemeSnippet>

      <MenuItem
        item={{
          title: 'Desconectar',
          icon: <LogoutRounded sx={{ color: COLORS.primary.main }} />,
        }}
        onClick={() => setDisplaySignOutDialog(true)}
        isMini={isMini}
      />
    </Fragment>
  );
};

export { LogoutMenu };
